import { createFileRoute } from '@tanstack/react-router'
import CheckoutPage from '../../screens/Checkout'

export const Route = createFileRoute('/c/checkout')({
  component: RouteComponent,
})

function RouteComponent() {
  return <div>
    <CheckoutPage />
  </div>
}
